export default __webpack_public_path__ + "static/CURRENT-OPENING-e516ceb6b628fd264e6b5b8643cc8d98.png";